import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import AdminPage from '../../components/admin/AdminPage';
import PreQualificationDetailCard from './components/PreQualificationDetailCard';
import PreQualificationDetailTabs from './components/PreQualificationDetailTabs';
import { AdminPreQualificationDetail } from './models/preQualificationModel';
import { getPreQualificationDetailEndpoint } from './services/preQualificationService';
import useAuth from '../../hooks/useAuth';
import useAdminEntity from '../../hooks/useAdminEntity';
import LoadingCard from '../../components/LoadingCard';

const PreQualificationDetail = () => {
  const { id = '' } = useParams();
  const [errorAlert, setErrorAlert] = useState<string | null>(null);

  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const getPreQualificationDetail = useCallback(
    () => getPreQualificationDetailEndpoint(id, token),
    [id, token],
  );

  const [preQualification, _, isLoading] =
    useAdminEntity<AdminPreQualificationDetail>(
      getPreQualificationDetail,
      setErrorAlert,
    );

  if (isLoading) {
    return <LoadingCard name="Detalle" parent_name="Pre-calificaciones" />;
  }

  if (!preQualification) {
    return null;
  }

  const detail = {
    name: `${preQualification.borrower.first_name} ${preQualification.borrower.last_name}`,
    loan_requested: preQualification.borrower_project.requested_loan_amount,
    score: preQualification.borrower.score,
    created_at: preQualification.created_at,
    banking_offers: preQualification.banking_offers,
    status: preQualification.status,
  };

  return (
    <AdminPage
      name="Detalle de precalificación"
      parentName="Pre-calificaciones"
      globalAlertOptions={{
        success: false,
        warning: Boolean(errorAlert),
        onConfirm: () => setErrorAlert(null),
        title: 'Error',
        text: errorAlert || '',
      }}
    >
      <div>
        <h2 className="h3 fw-bold mb-4">Detalle de precalificación</h2>
        <PreQualificationDetailCard detail={detail} />
        <PreQualificationDetailTabs pq={preQualification} />
      </div>
    </AdminPage>
  );
};

export default PreQualificationDetail;
